module.exports = __webpack_public_path__ + "img/trip-emission.9c45ce6a.svg";